import { get, put } from '../client'
import type { UserPreferences } from '../types/generated'

export async function fetchUserPreferences(): Promise<UserPreferences | null> {
  return get<UserPreferences | null>('api/hm/preferences')
}

export async function updateUserPreferences(prefs: UserPreferences): Promise<UserPreferences> {
  const response = await put<UserPreferences>('api/hm/preferences', prefs)
  if (!response) {
    throw new Error('Failed to update preferences')
  }
  return response
}
